import Axios, { AxiosInstance } from 'axios'
import qs from 'qs'

export default class Ajax {
  axiosInstance: AxiosInstance // add this line

  constructor(options: any) {
    this.axiosInstance = Axios.create(options)
  }

  /**
   * 内部方法: 根据api名称匹配完整路径··
   * @param {*} path
   */
  __getFullUrl(apiName: string, path: string) {
    if (!path || !path.length) {
      throw new Error(`API path cannot be empty`)
    }
    if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
      // 开发环境下且是客户端发起，使用/proxy-api标识来做接口代理，避免开发环境下跨域
      return `/proxy-api${path}`
    } else {
      return `${process.env.API_DOMAIN}${path}`
    }
  }

  /**
   * Get请求
   * @param {*} apiName
   * @param {*} url
   * @param {*} params
   * @param {*} options - 可选配置，包含cookie等
   * @returns
   */
  get(apiName: string, url: string, params: object, options?: { withCookies?: string }) {
    const config: any = {
      params,
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    
    // 如果传入了cookie，则添加到请求头中
    if (options?.withCookies) {
      config.headers = {
        'Cookie': options.withCookies,
        'Cache-Control': 'no-store',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'siteID': '2'
      }
    }
    
    return this.axiosInstance.get(this.__getFullUrl(apiName, url), config)
  }

  /**
   * POST请求
   * @param {*} apiName
   * @param {*} url
   * @param {*} params
   * @returns
   */
  post(apiName: string, url: string, data?: object) {
    return this.axiosInstance.post(this.__getFullUrl(apiName, url), data)
  }

  /**
   * PUT请求
   * @param {*} apiName
   * @param {*} url
   * @param {*} params
   * @returns
   */
  put(apiName: string, url: string, data: string) {
    return this.axiosInstance.put(this.__getFullUrl(apiName, url), data)
  }

  /**
   * DLETE请求
   * @param {*} apiName
   * @param {*} url
   * @param {*} config  query方式: {params:xxx }, body方式:{data:xxx}
   * @returns
   */
  delete(apiName: string, url: string, config: any) {
    return this.axiosInstance.delete(this.__getFullUrl(apiName, url), config)
  }
}
